import { memo } from 'react';
import { ClassListItem } from './ClassListItem';

const ClassListItemPlaceholderComponent = () => (
    <ClassListItem classId={undefined} linkTo="" openInNewTab={false} />
);

export const ClassListItemPlaceholder = memo(ClassListItemPlaceholderComponent);
